import { useNavigate, Link as RouterLink } from 'react-router-dom'
import { Button, useMediaQuery, useTheme, Link } from '@mui/material'
import ControlPointIcon from '@mui/icons-material/ControlPoint'

import { HelperWrapper } from 'src/components'
import { useAccount } from 'src/hooks'
import { EAccountSubscriptionPlans } from 'src/types'
import {
  ROUTES,
  SUBSCRIPTION_MAX_FREE_PRODUCTS_LIMIT,
  SUBSCRIPTION_MAX_PLUS_PRODUCTS_LIMIT,
} from 'src/constants'

import useStyles from './styles'
import { joinAbsRoute } from 'src/common/utils'

interface IAddLocationBtnProps {
  isDisabled: boolean
  handleClick: () => void
}

export const AddLocationBtn = ({ isDisabled, handleClick }: IAddLocationBtnProps) => {
  const { data: account, isLoading: isAccountLoading } = useAccount()
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('tablet'))

  const enterprisePlan = account?.subscription_plan === EAccountSubscriptionPlans.enterprise

  const upgradePremium =
    account?.subscription_plan === EAccountSubscriptionPlans.plus &&
    account?.productsCount >= SUBSCRIPTION_MAX_PLUS_PRODUCTS_LIMIT

  const upgradePlus =
    account?.subscription_plan === EAccountSubscriptionPlans.free &&
    account?.productsCount >= SUBSCRIPTION_MAX_FREE_PRODUCTS_LIMIT
  return (
    <div className={classes.addBtn}>
      <Button
        disabled={
          (isDisabled || isAccountLoading || upgradePlus || upgradePremium) && !enterprisePlan
        }
        color={'primary'}
        size={'small'}
        variant="contained"
        startIcon={<ControlPointIcon />}
        onClick={handleClick}
        style={{
          textWrap: 'nowrap',
        }}
      >
        <HelperWrapper t="button-add-new-text" isColorInherited />
      </Button>
      {(upgradePlus || upgradePremium) && (
        <div
          style={{
            color: theme.palette.custom.darkBlue2,
            fontSize: 14,
            marginLeft: isMobile ? 0 : 10,
            width: '95%',
          }}
        >
          <HelperWrapper t="location-add-upgrade-text" />
          &nbsp;
          <Link
            component={RouterLink}
            to={joinAbsRoute(ROUTES.ACCOUNTS, account?.id, `${ROUTES.ACCOUNT}?tab=billing`)}
          >
            <HelperWrapper t="upgrade-button-text" />
          </Link>
        </div>
      )}
    </div>
  )
}
